import { createState } from '../../lib/create-state';

export const [calls, resetCalls] = createState<number[]>([]);

export const [nextCalls, resetNextCalls] = createState<string[]>([]);

export const [gameToGo, resetGameToGo] = createState<Record<number, number>>(
    {}
);
